import React from 'react';
import Card from '../Card';

import './styles.css';

interface CardContainerProps {
  listaImobiliariasFiltrada: Array<any>,
  ambiente: string
};

const CardContainer: React.FC<CardContainerProps> = ({listaImobiliariasFiltrada,ambiente}) => {
  return (
    <div className="container-cards">
      {listaImobiliariasFiltrada.length > 0 
        ? listaImobiliariasFiltrada.map( (imobiliaria:any) => {
            return <Card key={imobiliaria.tenantId} imobiliaria={imobiliaria} ambiente={ambiente} />
          })
        : <p>Nenhuma imobiliária encontrada.</p>
      }
    </div>
  );
}

export default CardContainer;